import { FilterHeader, Props as FilterHeaderProps } from "./FilterHeader";

export const VersionHeader = (props: FilterHeaderProps) => {
    return <FilterHeader {...props} defaultSortOrder="desc" />;
};
